import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { cn } from 'src/common/utils';
import { primaryNavLinkClassName } from './PrimaryNav';

export const MobileProjectsLink = () => {
  const { t } = useTranslation('app');

  return (
    <Link
      to="/"
      aria-label={t('appbar.backToProjects')}
      className={cn(primaryNavLinkClassName(false), 'shrink-0 px-2')}
    >
      {t('appbar.projects')}
    </Link>
  );
};
